import React, { Component } from 'react';
import {
    Grid,
    FormControl
} from "@material-ui/core";
import WrappedAutocomplete from './WrappedAutocomplete';

class SelectClient extends Component {

    render() {
        let { inventories } = this.props

        return (
            <Grid item container>
                <FormControl variant="outlined" fullWidth>
                    <WrappedAutocomplete
                        label={"inventory"}
                        placeholder={"inventory"}
                        name="selectedInventory"
                        value={this.props.selectedInventory}
                        options={inventories}
                        onChange={this.props.handleChange}
                        getOptionLabel={option => option.inventoryName ? option.inventoryName : ""}
                        getOptionSelected={(option, value) => option.id === value.id}
                        renderOption={option => (
                            <React.Fragment>
                                {option.inventoryName ? option.inventoryName : ""}
                            </React.Fragment>
                        )}
                    />
                </FormControl>
            </Grid>
        );
    }
}

export default SelectClient;
